module.exports = __webpack_public_path__ + "static/media/sr.665578e8.svg";